module.exports = __webpack_public_path__ + "static/media/my-account-bg.92f42fe7.jpg";